// extracted by mini-css-extract-plugin
module.exports = {"list":"AppliedRules_list__1tyu3","emptyBox":"AppliedRules_emptyBox__17rt9","rule":"AppliedRules_rule__i2Ve8","mutedText":"AppliedRules_mutedText__1TL5z"};